import * as React from 'react';
import { cn } from '../../../helpers';

function VideoEmbed({ className, videoId, type, title, autoplay, onLoaded }: VideoEmbedProps) {
    const autoPlay = autoplay ? 1 : 0;

    const videoEmbedType = {
        vidyard: `//play.vidyard.com/${videoId}.html?v=3.1.1&autoplay=${autoPlay}`,
        youtube: `https://www.youtube.com/embed/&autoplay=${autoPlay}`
    };

    const onVideoLoaded = () => {
        if (onLoaded) onLoaded();
    };

    return (
        <div className={cn('video-embed-container', className)}>
            <iframe
                allowFullScreen
                className="video-iframe"
                frameBorder="0"
                style={{
                    width: '100%',
                    height: '100%'
                }}
                scrolling="no"
                src={videoEmbedType[type]}
                title={title}
                onLoad={() => onVideoLoaded()}
            />
        </div>
    );
}

export default React.memo(VideoEmbed);
